module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activityInfo) ? _c('div', {
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('div', {
    staticClass: "top-bar com-model m-b-24",
    staticStyle: {
      "padding": "11px 24px"
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/jobfair'
      }
    }
  }, [_vm._v("招聘会")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/jobfair/info',
        query: {
          jbid: _vm.activityInfo.id
        }
      }
    }
  }, [_vm._v("招聘会详情")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("企业报名表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "com-model",
    staticStyle: {
      "padding": "0 25px 38px"
    }
  }, [_c('div', {
    staticClass: "title m-b-24"
  }, [_vm._v("企业报名表")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap m-b-16"
  }, [_c('div', {
    staticClass: "flex company-item"
  }, [_c('div', {
    staticClass: "hadbm-list-name"
  }, [_vm._v("企业名称： ")]), _vm._v(" "), _c('div', {
    staticClass: "hadbm-list-namein"
  }, [_vm._v(_vm._s(_vm.$store.state.hrinfo.companyName))])]), _vm._v(" "), _c('div', {
    staticClass: "flex company-item"
  }, [_c('div', {
    staticClass: "hadbm-list-name"
  }, [_vm._v("联系人： ")]), _vm._v(" "), _c('div', {
    staticClass: "hadbm-list-namein"
  }, [_vm._v(_vm._s(_vm.activityInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex company-item"
  }, [_c('div', {
    staticClass: "hadbm-list-name"
  }, [_vm._v("联系方式： ")]), _vm._v(" "), _c('div', {
    staticClass: "hadbm-list-namein"
  }, [_vm._v(_vm._s(_vm.activityInfo.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "flex company-item"
  }, [_c('div', {
    staticClass: "hadbm-list-name"
  }, [_vm._v("举办地址： ")]), _vm._v(" "), _c('div', {
    staticClass: "hadbm-list-namein"
  }, [_vm._v(_vm._s(_vm.activityInfo.address))])])]), _vm._v(" "), (!!_vm.activityInfo.seatImage) ? _c('div', {}, [_c('div', {
    staticClass: "in-title"
  }, [_vm._v("场地平面图")]), _vm._v(" "), _c('div', {
    staticClass: "seat-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.activityInfo.seatImage,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.seatInfo.length > 0) ? _c('div', {
    staticClass: "tanwei m-b-14"
  }, [_c('div', {
    staticClass: "tanwei-tit m-b-16"
  }, [_c('span', [_vm._v("选择摊位")]), (_vm.seatno) ? _c('span', [_vm._v(",  您已选择"), _c('span', {
    staticStyle: {
      "color": "rgba(5, 124, 249, 1)"
    }
  }, [_vm._v(_vm._s(_vm.seatno))]), _vm._v("摊位")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tanwei-list flex flex-wrap"
  }, _vm._l((_vm.seatInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tanwei-item",
      class: {
        'active': item.id == _vm.seatid
      },
      on: {
        "click": function($event) {
          _vm.searSel(item.id, item.no)
        }
      }
    }, [_vm._v(_vm._s(item.no))])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.seatInfo.length && _vm.tempseatInfo.length) ? _c('div', {
    staticClass: "tanwei m-b-14"
  }, [_c('div', {
    staticClass: "tanwei-tit tanwei-temptit m-b-16"
  }, [_c('span', {
    staticClass: "tanwei-temptit-sd"
  }, [_vm._v("临时摊位")]), (_vm.seatno) ? _c('span', [_vm._v(",  您已选择"), _c('span', {
    staticStyle: {
      "color": "rgba(5, 124, 249, 1)"
    }
  }, [_vm._v(_vm._s(_vm.seatno))]), _vm._v("摊位")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tanwei-list tanwei-templist flex flex-wrap"
  }, [_vm._l((_vm.tempseatInfo), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        'active': item.id == _vm.seatid
      },
      on: {
        "click": function($event) {
          _vm.searSel(item.id, item.no)
        }
      }
    }, [_vm._v(_vm._s(item.no))])
  }), _vm._v(_vm._s(_vm.seatno) + "摊位")], 2), _vm._v(" "), _c('div', {
    staticClass: "tanwei-list tanwei-templist flex flex-wrap"
  }, _vm._l((_vm.tempseatInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tanwei-item",
      class: {
        'active': item.id == _vm.seatid
      },
      on: {
        "click": function($event) {
          _vm.searSel(item.id, item.no)
        }
      }
    }, [_vm._v(_vm._s(item.no))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    staticStyle: {
      "width": "160px"
    },
    on: {
      "click": _vm.subJobfair
    }
  }, [_vm._v("提交报名信息")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e4c1b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Jobfairseat.vue
// module id = 865
// module chunks = 1